export default (request, store) => {
  const getPostResult = (config) => {
    let str = ''
    let param = Object.keys(config)
    param.forEach((key, index) => {
      str += `${key}=${config[key]}`
      if (index < (param.length - 1)) {
        str += '&'
      }
    })
    console.log(str)
    return request.post(`/app/app.php?${str}`, config)
  }
  return {
    getPostResult
  }
}
